
  export default { props: { bundle: { type: Object, required: true } } };
